import * as React from 'react';
import {Stack, CardContent, Card, Grid} from '@mui/material';
import Typography from '@mui/material/Typography';
import IconButton from "@mui/material/IconButton";
import PeopleOutlineOutlinedIcon from '@mui/icons-material/PeopleOutlineOutlined';
import {find, reduce} from "lodash";
import {XYVO} from "@/service/analyze";
import Box from "@mui/material/Box";
import {OptionType} from "@/model/global";
import {useMemo} from "react";
import {useAuthInfo} from "@/store/account.c";

export interface WriteStatusAmountProps {
    writeCopyrightStatus?: XYVO[]
    option: OptionType
    writePatentStatus?: XYVO[]
    writeProjectStatus?: XYVO[]
    writeTrademarkStatus?: XYVO[]
}

export default function WriteStatusAmount({writeCopyrightStatus, writeTrademarkStatus, writePatentStatus, writeProjectStatus, option}: WriteStatusAmountProps) {
    const {username} = useAuthInfo()

    const calculateStatus = (status?: XYVO[]) => {
        const findStatus = find(status, item => item.x == username)
        if (findStatus) {
            return findStatus
        } else {
            return reduce(status, (prev, curr) => {
                prev.doing = prev.doing + parseInt(curr.doing)
                prev.done = prev.done + parseInt(curr.done)
                prev.pause = prev.pause + parseInt(curr.pause)
                return prev
            }, {doing: 0, done: 0, pause: 0})
        }
    }
    const writeStatus = useMemo(() => {
        switch (option.value) {
            case 1:
                return calculateStatus(writeProjectStatus)
            case 2:
                return calculateStatus(writePatentStatus)
            case 3:
                return calculateStatus(writeTrademarkStatus)
            case 4:
                return calculateStatus(writeCopyrightStatus)
        }
    }, [option, writeProjectStatus, writePatentStatus, writeTrademarkStatus, writeCopyrightStatus])

    return (
        <Grid container spacing={2}>
            <Grid size={4}>
                <Card variant="outlined" sx={{height: '100%', flexGrow: 1, position: 'relative', backgroundColor: '#ffe4ec'}}>
                    <CardContent sx={{height: 120}}>
                        <Stack justifyContent={'space-between'} height={'inherit'}>
                            <Stack justifyContent={'space-between'} direction={'row'} alignContent={'center'} alignItems={'center'}>
                                <Stack direction="row" spacing={1} alignContent={'center'} alignItems={'center'}>
                                    <IconButton size={'large'} sx={{bgcolor: '#ff6692', padding: '4px 12px', borderRadius: '99999px'}}>
                                        <PeopleOutlineOutlinedIcon fontSize={'medium'} sx={{color: '#fff'}}/>
                                    </IconButton>
                                </Stack>
                                <Box component='img' sx={{position: 'absolute', top: 0, right: 0}} src={'https://oss.kedaip.cn/keda/assets/shape.png'}/>
                            </Stack>
                            <Typography component={'h1'} variant={'subtitle1'} fontSize={24} fontWeight={600}>{writeStatus?.doing}</Typography>
                            <Typography component={'h4'} variant={'subtitle2'} color={'textSecondary'} fontSize={12}>进行中</Typography>
                        </Stack>
                    </CardContent>
                </Card>
            </Grid>
            <Grid size={4}>
                <Card variant="outlined" sx={{height: '100%', flexGrow: 1, position: 'relative', backgroundColor: '#e7e2f3'}}>
                    <CardContent sx={{height: 120}}>
                        <Stack justifyContent={'space-between'} height={'inherit'}>
                            <Stack justifyContent={'space-between'} direction={'row'} alignContent={'center'} alignItems={'center'}>
                                <Stack direction="row" spacing={1} alignContent={'center'} alignItems={'center'}>
                                    <IconButton size={'large'} sx={{bgcolor: '#8965e5', padding: '4px 12px', borderRadius: '99999px'}}>
                                        <PeopleOutlineOutlinedIcon fontSize={'medium'} sx={{color: '#fff'}}/>
                                    </IconButton>
                                </Stack>
                                <Box component='img' sx={{position: 'absolute', top: 0, right: 0}} src={'https://oss.kedaip.cn/keda/assets/shape.png'}/>
                            </Stack>
                            <Typography component={'h1'} variant={'subtitle1'} fontSize={24} fontWeight={600}>{writeStatus?.pause}</Typography>
                            <Typography component={'h4'} variant={'subtitle2'} color={'textSecondary'} fontSize={12}>暂停中</Typography>
                        </Stack>
                    </CardContent>
                </Card>
            </Grid>
            <Grid size={4}>
                <Card variant="outlined" sx={{height: '100%', flexGrow: 1, position: 'relative', backgroundColor: '#d2f9f4'}}>
                    <CardContent sx={{height: 120}}>
                        <Stack justifyContent={'space-between'} height={'inherit'}>
                            <Stack justifyContent={'space-between'} direction={'row'} alignContent={'center'} alignItems={'center'}>
                                <Stack direction="row" spacing={1} alignContent={'center'} alignItems={'center'}>
                                    <IconButton size={'large'} sx={{bgcolor: '#00ceb6', padding: '4px 12px', borderRadius: '99999px'}}>
                                        <PeopleOutlineOutlinedIcon fontSize={'medium'} sx={{color: '#fff'}}/>
                                    </IconButton>
                                </Stack>
                                <Box component='img' sx={{position: 'absolute', top: 0, right: 0}} src={'https://oss.kedaip.cn/keda/assets/shape.png'}/>
                            </Stack>
                            <Typography component={'h1'} variant={'subtitle1'} fontSize={24} fontWeight={600}>{writeStatus?.done}</Typography>
                            <Typography component={'h4'} variant={'subtitle2'} color={'textSecondary'} fontSize={12}>已完成</Typography>
                        </Stack>
                    </CardContent>
                </Card>
            </Grid>
        </Grid>
    );
}
